// extracted by mini-css-extract-plugin
export default {"wrap":"NG-z","fullWidth":"OG-z","hideOnDesktop":"PG-z","content":"QG-z","hasOpenedNav":"RG-z","crumbsList":"SG-z","dropdownsWrap":"TG-z"};